/**
 * Atributos de contacto que escribe la app Lustro
 * (ChatwootService::syncOrderContact). Son de solo lectura en el dashboard:
 * el proximo sync de la orden sobrescribe cualquier edicion manual.
 */
export const LUSTRO_SYNCED_ATTRIBUTES = [
  'direccion',
  'distrito',
  'orden_estado',
  'orden_subestado',
  'orden_subestado_taller',
  'orden_subestado_logistica',
  'orden_productos',
  'orden_total',
  'orden_pago',
  'orden_fecha_creacion',
  'orden_fecha_recojo',
  'orden_fecha_entrega',
];

export const isSyncedAttribute = attributeKey =>
  LUSTRO_SYNCED_ATTRIBUTES.includes(attributeKey);
